export default __webpack_public_path__ + "static/media/uploader-dexcom-2.07cc027e.png";